import React from 'react';

const ColumnTitle = ({ children }) => (
  <span className="font-medium text-gray-500 uppercase text-xxs">
    {children}
  </span>
);

export default ColumnTitle;
